export default {
  bestGiftIdeas: {
    id: 'shopping_assistant_gifting_plp_pill_best_gift_ideas',
    defaultMessage: 'Best {category} gift ideas',
  },
} as const
